export const HOSPICE_LOC_STATUSES = {
    ORIGINAL_MEDICARE_WITH_HOSPICE_AUTH: 'Original Medicare with Hospice Auth',
    INVOICE_MCO_DIRECTLY: 'Invoice MCO Directly',
    INVOICE_MCO_WITH_HOSPICE_PRIOR_AUTH: 'Invoice MCO with Hospice Prior Auth',
};
